import { ValidationStrategy } from "./validation.strategy";
import { UploadValidationStrategy } from "./upload.validation.strategy";
import { DefaultValidationStrategy } from "./default.validation.strategy";
import { NoValidationStrategy } from "./no-validation.strategy";
import { CollectionValidationStrategy } from "./collection.validation.strategy";
import { SwitchContainerValidationStrategy } from "./switch-container.validation.strategy";
import { ContainerValidationStrategy } from "./container.validation.strategy";
import { AttributeModel } from "../main/dynamic/model/attribute.model";
import { CompanyValidationStrategy } from "./company.validation.strategy";
import { OptionModel } from "../main/dynamic/model/option.model";
import { AddressValidationStrategy } from "./address.validation.strategy";
import { CheckboxValidationStrategy } from "./checkbox.validation.strategy";
import { TextValidationStrategy } from "./text.validation.strategy";
import { CalendarValidationStrategy } from "./calendar.validation.strategy";
import { SocialLoginValidationStrategy } from "./social-login.validation.strategy";
import { RepeaterValidationStrategy } from "./repeater.validation.strategy";

export class ValidationStrategyFactory {

    public static create(attribute: AttributeModel, optionsInjection: OptionModel[] = []): ValidationStrategy {
        switch (attribute.type.toLowerCase()) {
            case "address":
                return new AddressValidationStrategy(attribute, optionsInjection)
            case "calendarselect":
                return new CalendarValidationStrategy(attribute);
            case "checkbox":
                return new CheckboxValidationStrategy(attribute);
            case "company":
                return new CompanyValidationStrategy(attribute, optionsInjection)
            case "choicescontainer":
            case "content":
            case "section":
            case "group":
                return new ContainerValidationStrategy(attribute, optionsInjection)
            case "collection":
            case "collectionmultiple":
                return new CollectionValidationStrategy(attribute);
            case "repeater":
                return new RepeaterValidationStrategy(attribute);
            case "sociallogin":
                return new SocialLoginValidationStrategy(attribute);
            case "switchcontainer":
                return new SwitchContainerValidationStrategy(attribute, optionsInjection)
            case "task":
            case "datetime":
            case "template":
                return new NoValidationStrategy(attribute)
            case "file":
            case "upload":
                return new UploadValidationStrategy(attribute)
            case "text":
                return new TextValidationStrategy(attribute, optionsInjection)
            default:
                return new DefaultValidationStrategy(attribute, optionsInjection)
        }
    }
}